import { render, staticRenderFns } from "./SecurityAccordion.vue?vue&type=template&id=4327d66b&lang=pug&functional=true&"
import script from "./SecurityAccordion.vue?vue&type=script&lang=js&"
export * from "./SecurityAccordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports